export default "__VITE_ASSET__CUQG4Ojy__"